const DARK_MAP_TYPE_ID = 'custom#pt-map-dark';
let darkMapTypeRegistered = false;

function getSiteTheme() {
    const theme = document.documentElement.getAttribute('data-theme');
    return theme === 'dark' ? 'dark' : 'light';
}

function ensureDarkMapType(ymaps) {
    if (darkMapTypeRegistered) {
        return DARK_MAP_TYPE_ID;
    }

    ymaps.layer.storage.add(DARK_MAP_TYPE_ID, function() {
        const layer = new ymaps.Layer(
            'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&theme=dark&%c&%l',
            {
                projection: ymaps.projection.wgs84Mercator,
            }
        );

        layer.getZoomRange = function() {
            return ymaps.vow.resolve([0, 19]);
        };

        return layer;
    });

    ymaps.mapType.storage.add(
        DARK_MAP_TYPE_ID,
        new ymaps.MapType('Privettur dark', [DARK_MAP_TYPE_ID])
    );

    darkMapTypeRegistered = true;

    return DARK_MAP_TYPE_ID;
}

function applyYandexMapTheme(map, ymaps, theme) {
    if (!map || !ymaps) {
        return;
    }

    if (theme === 'dark') {
        map.setType(ensureDarkMapType(ymaps));
        return;
    }

    map.setType('yandex#map');
}

function applyYandexMapThemeFromSite(map, ymaps) {
    applyYandexMapTheme(map, ymaps, getSiteTheme());
}

function bindYandexMapThemeSync(map, ymaps) {
    if (!map || !ymaps || map.__ptThemeSyncBound) {
        return;
    }

    map.__ptThemeSyncBound = true;

    document.addEventListener('pt-theme-change', (event) => {
        const theme = event.detail && event.detail.theme ? event.detail.theme : getSiteTheme();
        applyYandexMapTheme(map, ymaps, theme);
    });
}

export {
    applyYandexMapTheme,
    applyYandexMapThemeFromSite,
    bindYandexMapThemeSync,
    getSiteTheme,
};
